const MONTHS_OPTIONS = require("../pages/group-travel-form/config/data/month-options.json");


const formatSelectedDates = (dates) => {
  if (!Array.isArray(dates)) {
    throw new Error("Input must be an array.");
  }

  if (dates.length === 0) {
    return [];
  }

  const validDates = dates.filter((date) => {
    return typeof date === "string" && /^\d{4}\.\d{1,2}$/.test(date);
  });

  if (validDates.length === 0) {
    return [];
  }

  const sortedDates = validDates.sort((a, b) => {
    const [yearA, monthA] = a.split(".").map(Number);
    const [yearB, monthB] = b.split(".").map(Number);
    return yearA === yearB ? monthA - monthB : yearA - yearB;
  });

  const result = [];
  let currentBlock = null;

  sortedDates.forEach((date, index) => {
    const [year, month] = date.split(".").map(Number);
    const monthName = MONTHS_OPTIONS.find(
      (option) => parseInt(option.value) === month
    )?.label.toLowerCase();

    if (!monthName) {
      throw new Error(`Invalid month value: ${month}`);
    }

    if (!currentBlock) {
      // Start a new block
      currentBlock = {
        year: year.toString(),
        start: monthName,
        end: monthName,
      };
    } else {
      const [prevYear, prevMonth] = sortedDates[index - 1]
        .split(".")
        .map(Number);

      if (year === prevYear && month === prevMonth + 1) {
        // If the months are consecutive, update the end month
        currentBlock.end = monthName;
      } else {
        // If not consecutive, push the current block and start a new one
        result.push(currentBlock);
        currentBlock = {
          year: year.toString(),
          start: monthName,
          end: monthName,
        };
      }
    }
  });

  if (currentBlock) result.push(currentBlock);

  return result;
};


  export { formatSelectedDates }